import { KeyValPair } from '@models/common.model'
import { Autocomplete, TextField, Tooltip, Typography } from '@mui/material'
import { find, isArray, isEqual, isObject, isString, merge } from 'lodash'
import { SyntheticEvent } from 'react'
import { Control, Controller } from 'react-hook-form'

export const FormAutocomplete = (props: {
	name: string
	control: Control<any>
	label: string | JSX.Element
	optionList: KeyValPair[]
	multiple?: boolean
	additionChangeAction?: (newValue: KeyValPair | KeyValPair[] | null) => void
	canDisabledClear?: boolean 
}) => {
	return (
		<Controller
			name={props.name}
			control={props.control}
			render={({ field: { ref, onChange, onBlur, value, ...rest } }) => {
				return (
					<Autocomplete
						disableClearable={props.canDisabledClear}
						ref={ref}
						value={
							props.multiple
								? props.optionList.filter((option) =>  value?.includes(option.key)) || []
								: props.optionList.find((option) => option.key === value ||( option.key?.[0] === value?.[0] && option.key.length === value.length) ) || null
						}
						multiple={props.multiple}
                        isOptionEqualToValue={(option: KeyValPair, value: KeyValPair | string) => {
							return isString(value) ? option.key === value : option.key === value.key
						}}
						onChange={(e: SyntheticEvent, newValue: KeyValPair | KeyValPair[] | null) => {
							const valueOnly = isArray(newValue)
								? newValue?.map((x) => x.key)
								: newValue?.key ?? ''
							onChange?.(valueOnly)
							if(props.additionChangeAction){
								props.additionChangeAction(newValue)
							}
						}}
						options={props.optionList ?? []}
						getOptionLabel={(option: KeyValPair) => option.value}
						renderInput={(params: any) => {
							const { InputProps, ...restParams } = params
							const { startAdornment, ...restInputProps } = InputProps

							return <TextField
								{...params}
								variant="standard"
								placeholder="Search"
								sx={{
									input: {
										color: 'black',
									},
								}}
								InputProps={{
									...restInputProps,
									startAdornment: (
									  <div
										style={{
										  maxHeight: '150px',
										  overflowY: 'auto',
										}}>
										{startAdornment}
									  </div>
									),
								  }}
							/>
						}}
						renderOption={(props, option) => {
							return (
								<li {...props} key={`${option.key}`}>
									<Tooltip title={option.value} followCursor>
										<Typography
											sx={{
												fontSize: '16px',
											}}
										>
											{option.value}
										</Typography>
									</Tooltip>
								</li>
							)
						}}
						{...rest}
					/>
				)
			}}
		/>
	)
}
